
<template>
  <div>
    <form
      class="form form-horizontal"
      role="form"
      @submit.prevent="saveVendor"
      id="ma-form"
      name="myForm"
      novalidate
    >
      <modal>
        <div slot="header">
          <button type="button" class="close" @click="CloseModal">&times;</button>
          <h2 class="modal-title">{{title== null? Vendor: title}}</h2>
        </div>

        <div slot="body">
          <div v-if="success_message != '' && success_message!=null">
            <div class="alert alert-success text-center">
              <strong>{{success_message}}</strong>
            </div>
          </div>
          <div v-if="vendor_message!=null && vendor_message!=''">
            <div class="alert alert-danger text-center">
              <strong>{{vendor_message}}</strong>
            </div>
          </div>
          <div v-if="message !=null && message!=''">
            <div class="alert alert-danger text-center">
              <strong>{{message}}</strong>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Name
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                name="Name"
                class="form-control"
                placeholder="Name"
                v-model="Vendor.Name"
                data-vv-validate-on="blur"
                autocomplete="off"
                maxlength="250"
                :class="{'input-validation-error': ((NameFlags.invalid && !NameFlags.pristine)||errors.has('Name'))}"
                v-validate="'required|alpha_spaces|max:250|name-validate'"
              />
              <span class="text-danger">{{errors.first('Name')}}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Address
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{'input-validation-error': ((AddressFlags.invalid && !AddressFlags.pristine)||errors.has('Address'))}"
                name="Address"
                placeholder="Address"
                v-model="Vendor.Address"
                maxlength="250"
                autocomplete="off"
                v-validate="'required|Address'"
                data-vv-validate-on="blur"
              />
              <span class="text-danger">{{errors.first('Address')}}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Contact No
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{'input-validation-error': ((ContactNoFlags.invalid && !ContactNoFlags.pristine)||errors.has('ContactNo'))}"
                name="ContactNo"
                placeholder="Contact No"
                data-vv-as="Contact Number"
                v-model="Vendor.ContactNo"
                v-validate="'required|Phone_number_valid'"
                autocomplete="off"
                maxlength="50"
                data-vv-validate-on="blur"
              />
              <span class="text-danger">{{errors.first('ContactNo')}}</span>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Email
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{'input-validation-error': ((EmailFlags.invalid && !EmailFlags.pristine)||errors.has('Email'))}"
                name="Email"
                placeholder="Email"
                v-model="Vendor.Email"
                maxlength="100"
                autocomplete="off"
                v-validate="'required|email|max:100 '"
                data-vv-validate-on="blur"
              />
              <span class="text-danger">{{errors.first('Email')}}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Account No
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{'input-validation-error': ((AccNoFlags.invalid && !AccNoFlags.pristine)||errors.has('AccNo'))}"
                name="AccNo"
                placeholder="Account No"
                data-vv-as="Account Number"
                v-model="Vendor.AccNo"
                maxlength="50"
                data-vv-validate-on="blur"
                autocomplete="off"
                v-validate="'required|Alpha_Space_Number'"
              />
              <span class="text-danger">{{errors.first('AccNo')}}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Contract Date
                <span class="text-danger">*</span>
              </label>
              <date-pick
                v-model="Vendor.ContractDate"
                :format="'DD-MM-YYYY'"
                :inputAttributes="{class: ContractDateClass}"
                @input="ValueDateValid"
              ></date-pick>

              <!-- <input
                type="date"
                class="form-control"
                :class="{'input-validation-error': ((ContractDateFlags.invalid && !ContractDateFlags.pristine)||errors.has('ContractDate'))}"
                name="ContractDate"
                data-vv-as="Contract Date"
                v-model="Vendor.ContractDate"
                v-validate="'required|Date'"
                data-vv-validate-on="change|blur"
              >-->
              <span class="text-danger">{{errors.first('ContractDate')}}</span>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label for="deleted">Vendor Type</label>
              <select
                class="form-control"
                name="vendorType"
                data-vv-as="Vendor Type"
                v-model="Vendor.VendorTypeObject"
              >
                <option
                  v-for="(type,index) in vendorTypes"
                  :key="index"
                  :value="type.Type"
                >{{type.Name}}</option>
              </select>
              <span class="text-danger">{{errors.first('vendorType')}}</span>
            </div>
            <div class="col-xs-4">
              <label for="deleted">Deleted</label>
              <br />
              <input type="checkbox" v-model="Vendor.Deleted" />
              <span class="text-danger">{{errors.first('Deleted')}}</span>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <strong v-currentdate></strong>
            </div>
          </div>
        </div>

        <div slot="footer">
          <span class="pull-left text-danger">*Mandatory fields</span>
          <loading v-if="loading"></loading>
          <input type="submit" class="btn btn-primary" value="Save" />
          <button class="btn btn-warning" @click="CloseModal">Cancel</button>
        </div>
      </modal>
    </form>
  </div>
</template>

<script>
const dict = {
  custom: {
    ContractDate: {
      required: "Please select date format-'mm/dd/yyyy'"
      // required: 'Your email is empty'
    }
  }
};

import { mapFields } from "vee-validate";
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import VeeValidate, { Validator } from "vee-validate";
import DatePick from "vue-date-pick";
Validator.localize("en", dict);

export default {
  data() {
    return {
      success_message: null,
      title: "Vendor ",
      vendor_message: null,
      vendorTypes: [
        { Type: "S", Name: "Seller" },
        { Type: "B", Name: "Buyer" }
      ],
      Vendor: {
        Name: "",
        Address: "",
        ContactNo: "",
        Email: "",
        AccNo: "",
        VendorTypeObject: "",
        ContractDate: "",
        Deleted: false,
        VendorId: null,
        formattedCOntractdate: null
      },
      ContractDateClass: "form-control"
    };
  },
  props: { VendorId: Number },
  components: {
    DatePick
  },
  methods: {
    IsValidate(Name, _error) {
      if (this.Vendor[Name] == "" || this.Vendor[Name] == null) {
        this[Name + "Class"] = "form-control input-validation-error";
        this.$validator.errors.add({
          field: Name,
          msg: _error
        });
      } else {
        this[Name + "Class"] = "form-control";
        this.$validator.errors.remove(Name);
      }
    },
    ValueDateValid() {
      this.IsValidate("ContractDate", "Please select Contract Date");
    },
    saveVendor() {
      var vm = this;
      this.vendor_message = "";
      this.success_message = "";
      this.$validator.validateAll().then(result => {
        if (result) {
          var { Vendor } = this;
          Vendor.formattedCOntractdate = vm.GetCorrectFormat(
            Vendor.ContractDate
          );

          this.$store
            .dispatch(ACTIONS.VENDORS_SAVE, Vendor)
            .then(res => {
              var { data } = res;
              if (data && data.StatusCode == 200) {
                //vm.success_message = "Vendor Added Successfully";
                if (vm.Vendor.VendorId) {
                  vm.success_message = "Vendor modified Successfully";
                } else {
                  vm.success_message = "Vendor saved Successfully";
                }
                setTimeout(function() {
                  vm.success_message = null;
                  vm.CloseModal();
                }, 1500);
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    vm.$validator.errors.add({
                      field: prop,
                      msg: ResponseData[prop]
                    });
                  }
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          vm.vendor_message = "Please provide correct details.";
          setTimeout(function() {
            vm.vendor_message = null;
          }, 1800);
        }
      });
    },

    CloseModal() {
      this.$emit("Close");
    }
  },
  beforeMount() {
    var vm = this;
    if (this.VendorId && this.VendorId) {
      this.Vendor.VendorId = this.VendorId;
      this.$store
        .dispatch(ACTIONS.VENDOR_EDIT_REQUEST, this.VendorId)
        .then(res => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            var { vendor } = data.ResponseData;
            vm.Vendor.Name = vendor.Name;
            vm.Vendor.Address = vendor.Address;
            vm.Vendor.ContactNo = vendor.ContactNo;
            vm.Vendor.Email = vendor.Email;
            vm.Vendor.AccNo = vendor.AccNo;
            vm.Vendor.VendorTypeObject = vendor.Type;
            vm.Vendor.Deleted =
              vendor.Deleted == 0 || vendor.Deleted == null ? false : true;

            vm.Vendor.ContractDate = vm.setFormDate(vendor.ContractDate);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    var vm = this;
    VeeValidate.Validator.extend("name-validate", {
      validate: function(value, obj) {
        if (value) {
          //var Senddata = {id:0, value: value}
          var Senddata = { id: vm.Vendor.VendorId, value: value };
          return vm.$store
            .dispatch(ACTIONS.VENDORS_CHECK_DUP_NAME, Senddata)
            .then(res => {
              return { valid: res.data };
            })
            .catch(err => {
              return { valid: true };
            });
        }
      },
      getMessage: function(field, params, value) {
        return "Name is Already exist";
      }
    });
    VeeValidate.Validator.extend("Date", {
      validate: function(value, obj) {
        if (value) {
          var _date = value.split("-");
          var year = new Date().getFullYear();
          if (_date[0] && _date[1] && _date[2]) {
            if (_date[0] > year - 50 && _date[0] <= year) {
              return { valid: true };
            }
          }
          return { valid: false };
        }
        return { valid: false };
      },
      getMessage: function(field, params, value) {
        return "Date is not in valid format - mm/dd/yyyy or Invalid";
      }
    });
  },
  computed: {
    ...mapGetters({
      message: "saveError",
      loading: "Saveloading"
    }),
    ...mapFields({
      NameFlags: "Name",
      AddressFlags: "Address",
      ContactNoFlags: "ContactNo",
      EmailFlags: "Email",
      AccNoFlags: "AccNo",
      vendorTypeFlags: "vendorType",
      ContractDateFlags: "ContractDate"
    })
  }
};
</script>